/* Ollique theme — interactions: drawers, cart, quick add, product options, gallery, sticky add-to-cart. */
(() => {
  'use strict';
  const C = window.Ollique || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || C.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const re = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, d, t, dec) => {
      t = t == null ? ',' : t; dec = dec == null ? '.' : dec;
      if (n == null || isNaN(n)) return '0';
      const parts = (n / 100).toFixed(d).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? dec + parts[1] : '');
    };
    const m = format.match(re);
    if (!m) return format;
    let v;
    switch (m[1]) {
      case 'amount_no_decimals': v = fmt(cents, 0); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      default: v = fmt(cents, 2);
    }
    return format.replace(re, v);
  }

  /* ---------- Header height (for sticky elements) ---------- */
  const header = $('[data-header]');
  if (header && 'ResizeObserver' in window) {
    new ResizeObserver(() => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px')).observe(header);
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  const focusables = (el) => $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', el).filter((n) => n.offsetParent !== null);

  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    $$('.drawer.is-open').forEach((x) => x !== d && closeDrawer(x, false));
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('is-locked');
    const target = $('[data-autofocus]', d) || focusables($('.drawer__panel', d))[0];
    setTimeout(() => target && target.focus(), 60);
  }
  function closeDrawer(d, restore = true) {
    if (typeof d === 'string') d = document.getElementById(d);
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.documentElement.classList.remove('is-locked');
    if (restore && lastFocus && document.contains(lastFocus)) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      const id = opener.dataset.drawerOpen;
      if (id === 'cart-drawer' && document.body.classList.contains('template-cart')) return; // already on the bag page
      e.preventDefault();
      if (id === 'cart-drawer') renderCart(C.cart);
      openDrawer(id);
      return;
    }
    const closer = e.target.closest('[data-drawer-close]');
    if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); }
  });

  document.addEventListener('keydown', (e) => {
    const d = $('.drawer.is-open');
    if (!d) return;
    if (e.key === 'Escape') { closeDrawer(d); return; }
    if (e.key === 'Tab') {
      const f = focusables($('.drawer__panel', d));
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Cart ---------- */
  const cartError = $('[data-cart-error]');
  function showCartError(msg) { if (cartError) { cartError.textContent = msg; cartError.hidden = false; } }
  function hideCartError() { if (cartError) cartError.hidden = true; }
  const imgUrl = (u, w) => (u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');

  async function fetchCart() {
    const r = await fetch(C.routes.cart + '.js', { headers: { Accept: 'application/json' } });
    C.cart = await r.json();
    return C.cart;
  }

  function renderCart(cart) {
    if (!cart) return;
    $$('[data-cart-count]').forEach((n) => { n.textContent = cart.item_count; });
    $$('.header__cart').forEach((a) => a.setAttribute('aria-label', 'Bag, ' + cart.item_count + ' items'));
    const body = $('[data-cart-items]');
    const foot = $('[data-cart-foot]');
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p class="cart-empty__title">Your bag is empty</p><a class="btn" href="' + esc(C.routes.all) + '">Shop the collection</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    body.innerHTML = cart.items.map((it, i) => {
      const img = it.image ? '<img src="' + esc(imgUrl(it.image, 240)) + '" alt="' + esc(it.product_title) + '" width="120" height="160" loading="lazy">' : '';
      const variant = it.product_has_only_default_variant ? '' : '<p class="line__variant">' + esc(it.variant_title) + '</p>';
      return '<div class="line" data-line="' + (i + 1) + '">' +
        '<a class="line__media" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="line__info">' +
          '<a class="line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
          '<p class="line__price">' + formatMoney(it.final_line_price) + '</p>' +
          '<div class="line__row">' +
            '<div class="qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity of ' + esc(it.product_title) + '">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button></div>' +
            '<button type="button" class="line__remove" data-qty="0">Remove</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
    const sub = $('[data-cart-subtotal]');
    if (sub) sub.innerHTML = formatMoney(cart.total_price);
  }

  async function changeLine(line, quantity) {
    const body = $('[data-cart-items]');
    if (body) body.classList.add('is-busy');
    hideCartError();
    try {
      const r = await fetch(C.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      const data = await r.json();
      if (!r.ok) throw data;
      C.cart = data;
    } catch (err) {
      showCartError((err && (err.description || err.message)) || 'We couldn’t update your bag. Please try again.');
      await fetchCart();
    } finally {
      renderCart(C.cart);
      if (body) body.classList.remove('is-busy');
    }
  }

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-cart-items] [data-qty]');
    if (!b) return;
    const line = parseInt(b.closest('[data-line]').dataset.line, 10);
    changeLine(line, Math.max(0, parseInt(b.dataset.qty, 10)));
  });

  async function addToCart(items, btn, errorEl) {
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    if (errorEl) errorEl.hidden = true;
    try {
      const r = await fetch(C.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items })
      });
      const data = await r.json();
      if (!r.ok) throw data;
      await fetchCart();
      hideCartError();
      renderCart(C.cart);
      openDrawer('cart-drawer');
      return true;
    } catch (err) {
      const msg = (err && (err.description || err.message)) || 'We couldn’t add this to your bag. Please try again.';
      if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
      else { await fetchCart().catch(() => {}); renderCart(C.cart); showCartError(msg); openDrawer('cart-drawer'); }
      return false;
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  }

  /* ---------- Quick add on product cards ---------- */
  document.addEventListener('click', (e) => {
    const toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      e.preventDefault();
      const wrap = toggle.closest('.card__media-wrap');
      const panel = $('[data-quick-panel]', wrap);
      const opening = panel.hidden;
      $$('[data-quick-panel]').forEach((p) => { p.hidden = true; });
      $$('.card__quick[data-quick-toggle]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
      panel.hidden = !opening;
      $('.card__quick', wrap).setAttribute('aria-expanded', String(opening));
      if (opening) { const first = $('button:not([disabled])', $('.card__panel-options', panel)); if (first) first.focus(); }
      return;
    }
    const q = e.target.closest('[data-quick-add]');
    if (q) {
      e.preventDefault();
      addToCart([{ id: parseInt(q.dataset.quickAdd, 10), quantity: 1 }], q).then((ok) => {
        const panel = q.closest('[data-quick-panel]');
        if (ok && panel) panel.hidden = true;
      });
      return;
    }
    if (!e.target.closest('[data-quick-panel]')) $$('[data-quick-panel]').forEach((p) => { p.hidden = true; });
  });

  /* ---------- Product page ---------- */
  function initProduct(root) {
    const dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const sizeIndex = parseInt(root.dataset.sizeIndex, 10);
    const sizeName = root.dataset.sizeName || 'size';
    const title = root.dataset.title;
    const form = $('form.product-form', root);
    const idInput = $('[data-variant-id]', form);
    const atc = $('[data-atc]', root);
    const notify = $('[data-notify]', root);
    const help = $('[data-wa-help]', root);
    const priceEl = $('[data-price]', root);
    const formError = $('[data-form-error]', root);
    const qtyWrap = $('[data-qty-wrap]', root);
    const qtyInput = qtyWrap ? $('[data-qty-input]', qtyWrap) : null;
    const buyNow = $('[data-buy-now]', root);
    const groups = $$('[data-option-index]', root);
    const gallery = $('[data-gallery]', root);
    const sticky = $('[data-sticky-atc]');
    const stickyBtn = sticky && $('[data-sticky-btn]', sticky);
    const stickyPrice = sticky && $('[data-sticky-price]', sticky);
    const selected = groups.map((g) => { const c = $('input:checked', g); return c ? c.value : null; });

    /* Quantity selector */
    const getQty = () => { const n = parseInt(qtyInput && qtyInput.value, 10); return n > 0 ? n : 1; };
    if (qtyWrap && qtyInput) {
      qtyWrap.addEventListener('click', (e) => {
        const b = e.target.closest('[data-qty-step]');
        if (!b) return;
        qtyInput.value = Math.max(1, getQty() + parseInt(b.dataset.qtyStep, 10));
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      qtyInput.addEventListener('change', () => { qtyInput.value = getQty(); });
    }

    const waLink = (tpl, label) => {
      const msg = (tpl || '').replace(/\[product\]/g, title).replace(/\[size\]/g, label || '').replace(/\s*\(\s*\)/g, '').trim();
      return 'https://wa.me/' + C.whatsapp + '?text=' + encodeURIComponent(msg);
    };
    const findVariant = () => (selected.some((v) => v == null) ? null : variants.find((v) => v.options.every((o, i) => o === selected[i])) || null);

    function markAvailability() {
      groups.forEach((g, gi) => {
        $$('input', g).forEach((input) => {
          const ok = variants.some((v) => v.available && v.options[gi] === input.value &&
            v.options.every((o, i) => i === gi || selected[i] == null || o === selected[i]));
          input.closest('label').classList.toggle('is-unavailable', !ok);
        });
      });
    }

    let state = 'add';
    function update(changedIndex) {
      const v = groups.length ? findVariant() : variants[0];
      groups.forEach((g, gi) => { const l = $('[data-option-selected]', g); if (l) l.textContent = selected[gi] || ''; });
      markAvailability();

      if (!variants.some((x) => x.available)) state = 'soldout';
      else if (!groups.length) state = v && v.available ? 'add' : 'soldout';
      else if (!v && selected.some((s) => s == null)) state = 'select';
      else if (!v) state = 'soldout';
      else state = v.available ? 'add' : 'soldout';

      idInput.value = v ? v.id : '';
      form.dataset.state = state;
      const label = v ? v.title : selected.filter(Boolean).join(' / ');
      if (v && priceEl) priceEl.innerHTML = formatMoney(v.price) + (v.compare > v.price ? ' <s>' + formatMoney(v.compare) + '</s>' : '');
      if (v && stickyPrice) stickyPrice.innerHTML = formatMoney(v.price);

      if (atc) {
        atc.hidden = state === 'soldout';
        atc.textContent = state === 'select' ? 'Select a ' + sizeName : 'Add to cart';
      }
      if (qtyWrap) qtyWrap.hidden = state === 'soldout';
      if (buyNow) buyNow.hidden = state !== 'add';
      if (notify) { notify.hidden = state !== 'soldout'; notify.href = waLink(C.waNotify, label); }
      if (help) help.href = waLink(C.waHelp, state === 'select' ? '' : label);
      if (stickyBtn) stickyBtn.textContent = state === 'soldout' ? 'Notify me' : state === 'select' ? 'Select a ' + sizeName : 'Add to cart';
      if (formError) formError.hidden = true;

      if (changedIndex != null) {
        if (v) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (changedIndex !== sizeIndex && gallery && gallery.goToMedia) {
          const mv = (v && v.media) ? v : variants.find((x) => x.media && x.options.every((o, i) => selected[i] == null || o === selected[i]));
          if (mv && mv.media) gallery.goToMedia(mv.media);
        }
      }
    }

    function needSize() {
      const g = groups[sizeIndex];
      if (!g) return;
      g.classList.add('is-error');
      const err = $('[data-size-error]', g);
      if (err) err.hidden = false;
      g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      const first = $('input', g);
      if (first) setTimeout(() => first.focus({ preventScroll: true }), 300);
    }

    groups.forEach((g, gi) => {
      g.addEventListener('change', (e) => {
        if (!e.target.matches('[data-option-input]')) return;
        selected[gi] = e.target.value;
        g.classList.remove('is-error');
        const err = $('[data-size-error]', g);
        if (err) err.hidden = true;
        update(gi);
      });
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (state === 'select' || !idInput.value) { needSize(); return; }
      if (state !== 'add') return;
      addToCart([{ id: parseInt(idInput.value, 10), quantity: getQty() }], atc, formError);
    });

    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (state === 'add') { addToCart([{ id: parseInt(idInput.value, 10), quantity: getQty() }], stickyBtn); }
        else if (state === 'soldout' && notify) { window.open(notify.href, '_blank', 'noopener'); }
        else { needSize(); }
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          stickyBtn.tabIndex = show ? 0 : -1;
          document.body.classList.toggle('has-sticky-atc', show);
        }).observe(form);
      }
    }

    update(null);
  }

  /* ---------- Gallery ---------- */
  function initGallery(g) {
    const track = $('[data-track]', g);
    if (!track) return;
    const slides = $$('[data-media-id]', track);
    const dots = $$('[data-dot]', g);
    const thumbs = $$('[data-thumb]', g);
    const setActive = (i) => {
      dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
    };
    const go = (i, smooth = true) => {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };
    let ticking = false;
    track.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { setActive(Math.round(track.scrollLeft / track.clientWidth)); ticking = false; });
    }, { passive: true });
    thumbs.forEach((t) => t.addEventListener('click', () => go(parseInt(t.dataset.thumb, 10))));
    track.addEventListener('keydown', (e) => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(i + 1, slides.length - 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(i - 1, 0)); }
    });
    g.goToMedia = (id) => { const i = slides.findIndex((s) => String(s.dataset.mediaId) === String(id)); if (i > -1) go(i); };
  }

  /* ---------- Related products ---------- */
  function initRecommendations(el) {
    if (!el.dataset.url || el.children.length) return;
    fetch(el.dataset.url)
      .then((r) => r.text())
      .then((html) => {
        const tmp = document.createElement('div');
        tmp.innerHTML = html;
        const inner = $('[data-recommendations]', tmp);
        if (inner && inner.innerHTML.trim()) {
          el.innerHTML = inner.innerHTML;
          const section = el.closest('.related');
          if (section) section.hidden = false;
        }
      })
      .catch(() => {});
  }

  /* ---------- Auto-submit (sort select, cart quantities) ---------- */
  document.addEventListener('change', (e) => {
    const el = e.target.closest('[data-autosubmit]');
    if (el && el.form) el.form.submit();
  });

  /* ---------- Init ---------- */
  function init() {
    $$('[data-gallery]').forEach(initGallery);
    $$('[data-product]').forEach(initProduct);
    $$('[data-recommendations]').forEach(initRecommendations);
    renderCart(C.cart);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-gallery]', e.target).forEach(initGallery);
    $$('[data-product]', e.target).forEach(initProduct);
    $$('[data-recommendations]', e.target).forEach(initRecommendations);
  });
})();
